export default __webpack_public_path__ + "static/media/intro2.22935555.png";